var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudiALogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 125,
    viewBox: "0 0 243 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28721_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4557 109.465C10.4557 113.861 12.0181 115.547 17.0055 115.547H37.5564V124.398H14.4818C4.14623 124.398 0 120.906 0 111.392V86.6451C0 77.1316 4.08614 73.5791 14.4217 73.5791H36.9555V82.4905H17.0055C12.0181 82.4905 10.4557 84.1764 10.4557 88.5719V109.465Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8195 71.7725V124.398H42.3037V71.7725H52.8195Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4082 108.381V103.986C58.4082 91.8832 64.3571 87.3071 77.577 87.3071C90.7969 87.3071 96.6857 91.8832 96.6857 103.986V108.381C96.6857 120.604 90.8569 125 77.577 125C64.297 125 58.4082 120.604 58.4082 108.381ZM86.3502 107.96V104.347C86.3502 97.9646 84.4273 95.797 77.577 95.797C70.7267 95.797 68.8038 97.9646 68.8038 104.347V107.96C68.8038 114.884 71.6281 116.51 77.577 116.51C83.5259 116.51 86.3502 114.884 86.3502 107.96Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.06 87.9097V110.911C137.06 120.123 133.395 124.519 123.961 124.519H117.531C105.813 124.519 101.187 121.628 101.187 110.911V87.9097H111.582V105.19C111.582 112.657 111.282 115.728 118.372 115.728H120.175C127.085 115.728 126.725 112.296 126.725 105.19V87.9097H137.06Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.465 124.458C145.233 124.458 141.567 120.123 141.567 112.114V100.193C141.567 92.1843 145.233 87.9093 153.465 87.9093H167.106V71.7725H177.441V124.458H153.465ZM151.723 110.248C151.723 114.101 153.225 115.607 157.071 115.607H167.106V96.7604H157.071C153.225 96.7604 151.723 98.3861 151.723 102.059V110.248Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.21 70.749H194.327V81.7678H183.21V70.749ZM194.026 87.9094V124.398H183.51V87.9094H194.026Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.208 124.398H197.692L214.638 73.5791H225.334L243 124.398H232.485L228.639 112.898H211.874L208.208 124.398ZM214.818 103.806H225.574L220.106 87.3074L214.818 103.806Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9483 30.106C80.6509 30.106 73.9258 36.8447 73.9258 45.1589V60.2119H88.9483V30.106Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.971 45.159C103.971 53.4732 97.2457 60.212 88.9482 60.212H118.993V55.1341C114.612 49.6397 111.983 42.6853 111.983 35.1236C111.983 20.6828 121.547 8.43971 134.662 4.41554C130.1 1.61569 124.737 0 118.993 0C102.398 0 88.9482 13.4774 88.9482 30.106C97.2457 30.106 103.971 36.8447 103.971 45.159Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.971 45.1589C103.971 36.8447 97.2457 30.106 88.9482 30.106V60.2119C97.2457 60.2119 103.971 53.4732 103.971 45.1589Z",
    fill: "#F35F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.038 30.1058C149.038 42.0127 142.138 52.3039 132.123 57.1911C135.668 59.1179 139.724 60.2118 144.031 60.2118C157.857 60.2118 169.069 48.9772 169.069 35.1235C169.069 21.2697 157.857 10.0352 144.031 10.0352C143.175 10.0352 142.328 10.0803 141.492 10.1656C146.184 15.4793 149.038 22.4589 149.038 30.1058Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.993 60.2117H124.061C123.911 60.0913 123.76 59.9759 123.615 59.8555C122.108 60.0863 120.566 60.2117 118.993 60.2117Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.993 55.1343V60.2122C120.566 60.2122 122.108 60.0917 123.615 59.8559C121.918 58.4459 120.37 56.8604 118.993 55.1343Z",
    fill: "#F38221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.497 10.166C128.863 11.4405 118.998 22.1281 118.998 35.1289C118.998 44.6474 124.316 52.9416 132.128 57.1966C142.138 52.3144 149.043 42.0232 149.043 30.1112C149.043 22.4593 146.189 15.4797 141.497 10.171V10.166Z",
    fill: "#F38221"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28721_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudiALogo);
export default __webpack_public_path__ + "static/media/CloudiA_logo.796fa1ccbe8a2546b040e28b5b11f838.svg";
export { ForwardRef as ReactComponent };